const countsByTimePeriod = (state, getters) => (time_period) => {
  for (var i = 0; i < state.reward_counts.length; i++) { 
    if (state.reward_counts[i].id === getters.advertiser.id) {
      return state.reward_counts[i].counts.filter(count => count.timePeriod === time_period)
    }
  }
  return []
}

const impressionCountByTimePeriod = (state, getters) => (time_period) => {
  for (var i = 0; i < state.impression_counts.length; i++) { 
    if (state.impression_counts[i].id === getters.advertiser.id) {
      return state.impression_counts[i].counts.find(count => count.timePeriod === time_period)
    }
  }
  return undefined
}

const graphData = (state, getters, rootState) => {
  for (var i = 0; i < state.graph_counts.length; i++) { 
    if (state.graph_counts[i].id === getters.advertiser.id) {
      return state.graph_counts[i][rootState.time_period][rootState.count_type]
    }
  }
  return {}
}

export default {
  countsByTimePeriod,
  impressionCountByTimePeriod,
  graphData,
}